var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { withRouter } from "react-router";
import { Flex } from "rebass";
import styled from "styled-components";
import SearchIcon from "assets/svg/search.svg";
import { Button } from "src/components/elements/Button";
import Input from "src/components/elements/InputSearchbar";
var SearchIconStyled = styled(SearchIcon)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: inline-block;\n  width: auto;\n  height: 1.5em;\n  vertical-align: top;\n  fill: currentColor;\n  stroke-width: 0;\n  stroke: currentColor;\n"], ["\n  display: inline-block;\n  width: auto;\n  height: 1.5em;\n  vertical-align: top;\n  fill: currentColor;\n  stroke-width: 0;\n  stroke: currentColor;\n"])));
var Searchbar = function (_a) {
    var history = _a.history;
    var _b = useState(""), searchTerm = _b[0], setSearchTerm = _b[1];
    var t = useTranslation().t;
    var search = function (e) {
        e.preventDefault();
        history.push("/recherche/".concat(searchTerm));
    };
    return (React.createElement(Flex, { as: "form", onSubmit: search, alignItems: "center", css: "width: 100%; max-width: 43rem;" },
        React.createElement(Input, { sm: true, css: "flex: 1 1 100%; margin-right: 1rem", placeholder: t("header.searchPlaceholder"), type: "search", name: "search", value: searchTerm, onChange: function (e) { return setSearchTerm(e.target.value); }, results: 5 }),
        React.createElement(Button, { secondary: true, smIcon: true, css: "flex: 0 0 auto;", type: "submit", "aria-label": t("a11y.search") },
            React.createElement(SearchIconStyled, null))));
};
export default withRouter(Searchbar);
var templateObject_1;
